// 파일을 Data URL 형식으로 읽어오는 함수입니다.
export const readFileAsDataURL = async (file: Blob): Promise<string | ArrayBuffer | null> => {
  const reader = new FileReader();
  return new Promise((resolve, reject) => {
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
    reader.readAsDataURL(file);
    // 1. 읽어온 결과를 resolve 함수를 통해 반환합니다.
    // 2. 파일 읽기 실패 시 실행될 콜백 함수입니다.
    // 2. 에러를 reject 함수를 통해 반환합니다.
    // 3. 실제로 파일을 Data URL 형식으로 읽어옵니다.
  });
};
